import { QUIZ_TYPES_CONTANTS } from "../../../../types/quiz-constants";

const {
  NONE,
  IDENTIFICATION,
  ANAMNESE,
  DISCRIMINATION,
  CHILDHOOD_IDENTIFICATION_HC,
  RATINGS,
  CHILDHOOD_IDENTIFICATION,
  COGNITIVE,
  AUDIOMETRY,
} = QUIZ_TYPES_CONTANTS;

export const hideInputs = {
  maxShots: [COGNITIVE, AUDIOMETRY],
  anamnese: [] as Array<number>,
  screening: [
    NONE,
    IDENTIFICATION,
    ANAMNESE,
    DISCRIMINATION,
    CHILDHOOD_IDENTIFICATION_HC,
    RATINGS,
    CHILDHOOD_IDENTIFICATION,
  ],
};
